<div class="recommended-jobs">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="loading-text">{{ 'pages.jobs.recommendedJobs.loading' | transloco }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <i class="fas fa-exclamation-circle error-icon"></i>
    <p class="error-text">{{ error }}</p>
    <button mat-button color="primary" (click)="loadRecommendedJobs()">
      {{ 'common.retry' | transloco }}
    </button>
  </div>

  <!-- No Consent State -->
  <div *ngIf="!isLoading && !hasAiMatchingConsent" class="no-consent-state">
    <i class="fas fa-lock consent-icon"></i>
    <h3>{{ 'pages.jobs.recommendedJobs.noConsent.title' | transloco }}</h3>
    <p>
      {{ 'pages.jobs.recommendedJobs.noConsent.descriptionBefore' | transloco }}
      <a [routerLink]="getSettingsRoute()" class="settings-link">{{ 'pages.jobs.recommendedJobs.noConsent.settingsLinkText' | transloco }}</a>
      {{ 'pages.jobs.recommendedJobs.noConsent.descriptionAfter' | transloco }}
    </p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && hasAiMatchingConsent && mappedJobs.length === 0" class="empty-state">
    <i class="fas fa-magic empty-icon"></i>
    <h3>{{ 'pages.jobs.recommendedJobs.empty.title' | transloco }}</h3>
    <p>{{ 'pages.jobs.recommendedJobs.empty.description' | transloco }}</p>
    <button mat-raised-button color="primary" routerLink="/">
      {{ 'pages.jobs.recommendedJobs.empty.browseJobs' | transloco }}
    </button>
  </div>

  <!-- Recommended Jobs List -->
  <div *ngIf="!isLoading && !error && hasAiMatchingConsent && mappedJobs.length > 0" class="recommended-jobs-list">
    <div class="recommended-jobs-header">
      <h2>{{ 'pages.jobs.recommendedJobs.title' | transloco }}</h2>
      <div class="header-controls">
        <p class="jobs-count">
          {{ mappedJobs.length }} {{ 'pages.jobs.recommendedJobs.totalRecommendations' | transloco }}
        </p>
        <div class="limit-selector">
          <label for="recommended-limit-select" class="limit-selector__label">
            {{ 'pages.jobs.recommendedJobs.showJobs' | transloco }}:
          </label>
          <div class="limit-selector__wrap">
            <select
              id="recommended-limit-select"
              class="limit-selector__select"
              [value]="selectedLimit"
              (change)="onLimitChange(+$any($event.target).value)">
              <option *ngFor="let opt of limitOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <i class="fas fa-chevron-down limit-selector__chevron" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- AI Legal Disclaimer -->
    <div class="ai-disclaimer-container">
      <app-alert-card
        [translationKey]="'pages.jobs.recommendedJobs.aiDisclaimer'"
        [type]="'info'"
        [dismissible]="false">
      </app-alert-card>
    </div>

    <div class="jobs-grid">
      <app-job-detail-card
        *ngFor="let job of mappedJobs; let i = index"
        [job]="job"
        [mode]="'recommended'"
        [jobDetailRoute]="getJobDetailRoute(job)"
        [jobQueryParams]="getJobQueryParams(job)"
        (saveJob)="onSaveJob($event)"
        (unsaveJob)="onUnsaveJob($event)">
      </app-job-detail-card>
    </div>
  </div>
</div>
